import { createRouteRef } from '@backstage/frontend-plugin-api';

export const hojaDeVidaRouteRef = createRouteRef();
export const integracionesRouteRef = createRouteRef();
export const catalogoServiciosRouteRef = createRouteRef();
export const usuariosRouteRef = createRouteRef();
export const saludRouteRef = createRouteRef();
